module.exports = __webpack_public_path__ + "img/4.621f9a13.svg";